import React, { useState, useEffect } from "react";
import { StyledEngineProvider } from '@mui/material/styles';
import { Box, CircularProgress } from "@mui/material";
import CachedIcon from '@mui/icons-material/Cached';
import "./style.css";

import { PostEventDetails } from "../PostEventDetails";
import { DataGridVideoProcessing } from "../DatagridVideoProcessing";

import homeImage from '../../../icons/ImageIcons/material-symbols_home-rounded.svg';
import rightarrow from '../../../icons/ImageIcons/keyboard-arrow-right.svg';
import searchicon from '../../../icons/ImageIcons/searchicon.png';

import { getVideoProcessingStatusForEvent, setPostEventDetails } from "../../../store/Actions/PostEventAction";
import { FetchGradreelType } from "../../../store/Actions/PreEventAction";
import { connect } from "react-redux";
import { getClientData, setClientData } from "../../../constants/Constants";
import { useNavigate, useLocation } from "react-router-dom";
import { getLoginUser } from "../../../store/Actions/SharedAction";

const PostEventVideoProcessing = ({ loading, postEventDetails, getVideoProcessingStatusForEvent, videoProcessingStatus, loginUserDetails, getLoginUser, setPostEventDetails, eventMaster, getEventMaster }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedRowCount, setSelectedRowCount] = useState([]);
  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [deepLinkBootstrap, setDeepLinkBootstrap] = useState(false);

  const clientData = getClientData();

  useEffect(() => {
    if (postEventDetails) return;

    const params = new URLSearchParams(location.search);
    const queryValue = params.get('Query') || params.get('query');
    if (queryValue) {
      setDeepLinkBootstrap(true);
      getLoginUser(queryValue);
    } else {
      navigate('/PostEventDetailsDashboard');
    }
  }, [location.search, postEventDetails]);

  useEffect(() => {
    if (!deepLinkBootstrap || postEventDetails) return;

    const result = loginUserDetails?.result;
    if (result?.eventID) {
      setClientData(result);
      setPostEventDetails({
        clientId: result.clientID,
        eventId: result.eventID,
        eventName: result.eventName || '',
        eventDateTime: result.eventDateTime || result.eventDateTimeInUTC || null,
      });
      setDeepLinkBootstrap(false);
    } else if (loginUserDetails?.isSuccess === false) {
      setDeepLinkBootstrap(false);
      navigate('/PostEventDetailsDashboard');
    }
  }, [deepLinkBootstrap, loginUserDetails?.isSuccess, loginUserDetails?.result?.eventID, postEventDetails]);

  useEffect(() => {
    if (!postEventDetails) return;

    const client = getClientData();
    const clientId = client?.clientID || postEventDetails.clientId;

    if (clientId) {
      getVideoProcessingStatusForEvent(clientId, postEventDetails.eventId);
      getEventMaster({ clientId, eventId: postEventDetails.eventId });
    }
  }, [postEventDetails]);

  useEffect(() => {
    const hydratedEventName = eventMaster?.result?.eventData?.eventName;
    const hydratedEventDateTime = eventMaster?.result?.eventData?.eventDateTime
      || eventMaster?.result?.eventData?.eventDateTimeInUTC
      || null;

    if (!postEventDetails || (!hydratedEventName && !hydratedEventDateTime)) {
      return;
    }

    const nextEventName = hydratedEventName || postEventDetails.eventName || '';
    const nextEventDateTime = hydratedEventDateTime || postEventDetails.eventDateTime || null;

    if (postEventDetails.eventName === nextEventName && postEventDetails.eventDateTime === nextEventDateTime) {
      return;
    }

    setPostEventDetails({
      ...postEventDetails,
      eventName: nextEventName,
      eventDateTime: nextEventDateTime,
    });
  }, [
    eventMaster?.result?.eventData?.eventName,
    eventMaster?.result?.eventData?.eventDateTime,
    eventMaster?.result?.eventData?.eventDateTimeInUTC,
    eventMaster?.result?.eventData?.EventDateTime,
    eventMaster?.result?.eventData?.EventDateTimeInUTC,
    postEventDetails?.clientId,
    postEventDetails?.eventId,
    postEventDetails?.eventName,
    postEventDetails?.eventDateTime,
  ]);

  const filterRows = (query) => {
    return rows.filter(row =>
      row.customerId.toLowerCase().includes(query.toLowerCase()) ||
      row.customerName.toLowerCase().includes(query.toLowerCase())
    );
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const sortedRows = (Array.isArray(videoProcessingStatus?.result?.customerClipDetails?.customerDetails)
      ? videoProcessingStatus?.result?.customerClipDetails?.customerDetails
      : [])
      .map(row => ({
        id: row.customerId,
        customerId: row.customerId,
        customerName: row.customerName,
        encodingStatus: row.encodingStatus,
        expectedPath: row.expectedPath,
        isClipAvailable: row.isClipAvailable,
        isError: row.isError,
      }))
      .sort((a, b) => a.customerName.localeCompare(b.customerName));
    setRows(sortedRows);
  }, [videoProcessingStatus]);

  const getVideosInProcess = () => {
    if (videoProcessingStatus?.result?.customerClipDetails) {
      const { total, completed, failed } = videoProcessingStatus.result.customerClipDetails;
      const videosInProcess = total - completed - failed;
      return videosInProcess >= 0 ? videosInProcess : 0;
    }
    return 0;
  };

  const handleRefresh = () => {
    const clientId = clientData?.clientID || postEventDetails?.clientId;
    if (clientId && postEventDetails?.eventId) {
      getVideoProcessingStatusForEvent(clientId, postEventDetails.eventId);
      getEventMaster({ clientId, eventId: postEventDetails.eventId });
    }
  };

  const displayEventName = eventMaster?.result?.eventData?.eventName || postEventDetails?.eventName || '';

  return (
    <div className="video-processing-dashboard">
      <div className="div-2">
        <PostEventDetails />
        <div className="frame-19">
          <div className="frame-20">
            <div className="section-title">
              <div className="frame-21">
                <div className="page-title">
                  <div className="pagetitle">Post Event Details</div>
                </div>
                <div className="breadcrum">
                  <img className="material-symbols" alt="Material symbols" src={homeImage} />
                  <img className="keyboard-arrow-right" alt="Keyboard arrow right" src={rightarrow} />
                  <div className="text-wrapper-4">Post Event Details</div>
                  <img className="keyboard-arrow-right" alt="Keyboard arrow right" src={rightarrow} />
                  <div className="text-wrapper-5">Videos Processing Dashboard</div>
                </div>

                <div className="video-review-stats">
                  <div className="video-review-stats__item">
                    <span className="video-review-stats__label">Total Videos:</span>&nbsp;
                    <span className="video-review-stats__value">{videoProcessingStatus?.result?.customerClipDetails?.total}</span>
                  </div>
                  <div className="video-review-stats__item">
                    <span className="video-review-stats__label">Videos in Process:</span>&nbsp;
                    <span className="video-review-queue">{getVideosInProcess()}</span>
                  </div>
                  <div className="video-review-stats__item">
                    <span className="video-review-stats__label">Videos Failed:</span>&nbsp;
                    <span className="video-review-rejected">{videoProcessingStatus?.result?.customerClipDetails?.failed}</span>
                  </div>
                  <div className="video-review-stats__item">
                    <span className="video-review-stats__label">Videos Succeeded:</span>&nbsp;
                    <span className="video-review-approved">{videoProcessingStatus?.result?.customerClipDetails?.completed}</span>
                  </div>
                </div>
              </div>
            </div>
            {postEventDetails && (
              <div className="event-card">
                <div className="event-details">
                  <p><strong>Event Details: </strong> {postEventDetails.eventId} - {displayEventName}</p>
                </div>
              </div>
            )}
            <div className="frame-data">
              <div className="frame-datasearch">
                <div className="frame-datasearch2">
                  <div className="search">
                    <p className="label-and">
                      <input className="input" placeholder="Search" type="text" value={searchQuery} onChange={handleSearchChange} />
                    </p>
                    <img className="generic" alt="Generic" src={searchicon} />
                  </div>
                </div>
                <button className="refresh-button" onClick={handleRefresh}>
                  <CachedIcon className="refresh-icon" />
                </button>
              </div>

              <div className="frame-datagrid">
                <StyledEngineProvider injectFirst>
                  <DataGridVideoProcessing rows={filterRows(searchQuery)} setSelectedRowCount={setSelectedRowCount} selectedRowCount={selectedRowCount} />
                </StyledEngineProvider>
              </div>
              {(loading || deepLinkBootstrap) && (
                <div className="loader-container">
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
                    <CircularProgress />
                  </Box>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.postEvent.loading,
    postEventDetails: state.postEvent.postEventDetails,
    videoProcessingStatus: state.postEvent.videoProcessingStatus,
    loginUserDetails: state.shared.loginUserDetails,
    eventMaster: state.preEvent.gradreelType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVideoProcessingStatusForEvent: (clientId, eventId) => dispatch(getVideoProcessingStatusForEvent(clientId, eventId)),
    getLoginUser: (query) => dispatch(getLoginUser(query)),
    setPostEventDetails: (details) => dispatch(setPostEventDetails(details)),
    getEventMaster: (eventData) => dispatch(FetchGradreelType(eventData)),
  };
};

const ConnectedPostEventVideoProcessing = connect(mapStateToProps, mapDispatchToProps)(PostEventVideoProcessing);

export { ConnectedPostEventVideoProcessing as PostEventVideoProcessing };